import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconFolderAddLeft: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconFolderAddLeft"><Path d="M10.5352 3H2V11H8V14H11V20H22V6H12.5352L10.5352 3Z" fill="currentColor"/><Path d="M6 16V13H4V16H1V18H4V21H6V18H9V16H6Z" fill="currentColor"/></CentralIconBase>;
});

export default IconFolderAddLeft;
